import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setPreloadedASRStory, clearPreloadedASRStory, selectStudentPreChecks } from '../studentPreChecksSlice'
import { getASRStoryId } from '../StudentASRChecks/utils/ASRUtils'
import { getUserData } from '../../../services/API'
import { getStory } from '../../../services/API'

export default function useASRStoryPreload() {
  const dispatch = useDispatch()
  const { contextStates } = useSelector(selectStudentPreChecks)
  const preloadInProgress = useRef(false)

  const preloadASRStory = async () => {
    if (preloadInProgress.current) {
      return
    }

    // Check if we already have a preloaded story
    if (contextStates.preloadedASRStory) {
      return
    }

    preloadInProgress.current = true

    try {
      const userData = getUserData()
      const asrStoryId = getASRStoryId(userData)
            
      const story = await getStory(asrStoryId)
            
      dispatch(setPreloadedASRStory({
        story,
        storyId: asrStoryId
      }))
    } catch (error) {
      // Don't clear preloaded story on error - let it try again
    } finally {
      preloadInProgress.current = false
    }
  }

  const clearPreloadedStory = () => {
    dispatch(clearPreloadedASRStory())
  }

  return {
    preloadASRStory,
    clearPreloadedStory,
    preloadedStory: contextStates.preloadedASRStory,
    preloadedStoryId: contextStates.preloadedASRStoryId
  }
}
